export default __webpack_public_path__ + "static/media/sanmar20.ff7e3458.jpg";